import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        themes: {
            light: {
            primary: '#0007c7',
            info: '#4b51fb',
            background: '#fff'
            }
        },
        options: {
            customProperties: true
        }
    }
});
